import React, { PropsWithChildren } from 'react';
import cn from 'classnames';
import { useDeviceType } from '@cian/ui-kit';

import styles from './styles.css';

export const FAQBlocksLayout: React.FC<PropsWithChildren> = props => {
  const deviceType = useDeviceType();

  return <div className={cn(styles['layout'], styles[deviceType])}>{props.children}</div>;
};
